import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2, Car, Mail } from 'lucide-react';
import { Input } from '../../components/ui/input';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdminVehicles = () => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    axios
      .get(`${API_URL}/api/admin/vehicles`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      })
      .then((r) => setVehicles(r.data))
      .catch(() => toast.error('Failed to load vehicles'))
      .finally(() => setLoading(false));
  }, []);

  const filtered = vehicles.filter((v) => {
    if (!search.trim()) return true;
    const q = search.toLowerCase();
    return (
      v.make?.toLowerCase().includes(q) ||
      v.model?.toLowerCase().includes(q) ||
      v.color?.toLowerCase().includes(q) ||
      v.owner_name?.toLowerCase().includes(q) ||
      v.owner_email?.toLowerCase().includes(q) ||
      String(v.year).includes(q)
    );
  });

  return (
    <div data-testid="admin-vehicles">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
        <div>
          <h1 className="font-['Oswald'] text-3xl text-[#F2EDE6]">MEMBER VEHICLES</h1>
          <p className="text-[#A19D98] text-sm mt-1">
            {vehicles.length} vehicles across the rally family.
          </p>
        </div>
        <Input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search make / model / owner"
          data-testid="vehicles-search-input"
          className="bg-[#141414] border-[#2A2A2A] text-[#F2EDE6] sm:w-64"
        />
      </div>

      {loading ? (
        <div className="text-center py-12">
          <Loader2 className="w-8 h-8 text-[#E8651A] animate-spin mx-auto" />
        </div>
      ) : filtered.length === 0 ? (
        <p className="text-[#A19D98]">No vehicles yet.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {filtered.map((v) => (
            <div
              key={v.id}
              data-testid={`admin-vehicle-${v.id}`}
              className="bg-[#141414] border border-[#2A2A2A] overflow-hidden"
            >
              {v.photo_base64 ? (
                <img src={v.photo_base64} alt="" className="w-full h-40 object-cover" />
              ) : (
                <div className="w-full h-40 bg-[#1C1C1C] flex items-center justify-center">
                  <Car className="w-10 h-10 text-[#2A2A2A]" />
                </div>
              )}
              <div className="p-4">
                <h3 className="font-['Oswald'] text-[#F2EDE6] tracking-wider">
                  {v.year} {v.make.toUpperCase()} {v.model.toUpperCase()}
                </h3>
                <p className="text-[#A19D98] text-xs">{v.color}</p>
                {v.mods && <p className="text-[#A19D98] text-xs mt-1 italic">{v.mods}</p>}
                <div className="mt-3 pt-3 border-t border-[#2A2A2A] text-xs">
                  <p className="text-[#F2EDE6]">{v.owner_name}</p>
                  <a
                    href={`mailto:${v.owner_email}`}
                    className="text-[#A19D98] hover:text-[#E8651A] flex items-center gap-1"
                  >
                    <Mail size={11} /> {v.owner_email}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminVehicles;
